import { gql } from '../../../apollo/__generated__';

export const BEDROOMS = gql(`
  query Bedrooms($placeId: ID!) {
    bedrooms(placeId: $placeId) {
      id
      floor
      doorNumber
      maxUsers
    }
  }
`);
